import React from "react";

export const AIRLINE = (appliedLabel?: string) =>
  appliedLabel ? (
    <span className="filter-name">Airline: {appliedLabel}</span>
  ) : (
    <span className="filter-name">Airline</span>
  );
